import { Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import { IProfileContact } from '../../../Models/Profile/IProfileContact';

interface IContactFormProps {
    propertyChanged: (key: string, value: any) => void;
    contactInfo: IProfileContact;
    isLoading: boolean;
    isValid: (valid: boolean) => void;
}


export const ContactForm: React.FunctionComponent<IContactFormProps> = (props) => {

    const setInfoChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    React.useEffect(() => {
        const valid = props.contactInfo.firstName !== "" && props.contactInfo.lastName !== "" && props.contactInfo.phoneNumber !== "" && props.contactInfo.street !== "" && props.contactInfo.city !== "" && props.contactInfo.postalCode !== "";
        props.isValid(valid);

    }, [props.contactInfo])

    return (<Stack tokens={{ childrenGap: 15 }}>
        <TextField required id="firstName" key="firstName" label="Jméno" disabled={props.isLoading} value={props.contactInfo.firstName}
            onChange={setInfoChange} />
        <TextField required id="lastName" key="lastName" label="Příjmení" disabled={props.isLoading} value={props.contactInfo.lastName}
            onChange={setInfoChange} />

        <TextField required id="phoneNumber" key="phoneNumber" label="Telefon" disabled={props.isLoading} value={props.contactInfo.phoneNumber}
            onChange={setInfoChange} />
        <TextField required id="street" key="street" label="Ulice" disabled={props.isLoading} value={props.contactInfo.street}
            onChange={setInfoChange} />
        <TextField required id="city" key="city" label="Město" disabled={props.isLoading} value={props.contactInfo.city}
            onChange={setInfoChange} />
        <TextField required id="postalCode" key="postalCode" label="PSČ" disabled={props.isLoading} value={props.contactInfo.postalCode}
            onChange={setInfoChange} />
    </Stack>)
}
